import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-gradient-to-br from-primary via-primary-dark to-neutral-dark relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-5xl lg:text-6xl font-bold text-white mb-6">
            {t('cta_title')}
          </h2>
          <p className="text-xl text-white/90 mb-12 max-w-2xl mx-auto">
            {t('cta_subtitle')}
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => navigate('/register-nft')}
              className="px-12 py-5 bg-white text-primary text-lg font-bold rounded-full shadow-2xl hover:shadow-white/30 transition-all cursor-pointer whitespace-nowrap"
            >
              {t('cta_btn_register')}
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => navigate('/verify')}
              className="px-12 py-5 bg-transparent text-white text-lg font-bold rounded-full border-3 border-white hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
            >
              {t('cta_btn_verify')}
            </motion.button>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-20 pt-12 border-t border-white/20">
            <div className="text-center">
              <i className="ri-shield-check-line text-5xl text-white/80 mb-4"></i>
              <h4 className="text-white font-semibold mb-2">{t('cta_trust1_title')}</h4>
              <p className="text-white/70 text-sm">{t('cta_trust1_desc')}</p>
            </div>
            <div className="text-center">
              <i className="ri-time-line text-5xl text-white/80 mb-4"></i>
              <h4 className="text-white font-semibold mb-2">{t('cta_trust2_title')}</h4>
              <p className="text-white/70 text-sm">{t('cta_trust2_desc')}</p>
            </div>
            <div className="text-center">
              <i className="ri-customer-service-line text-5xl text-white/80 mb-4"></i>
              <h4 className="text-white font-semibold mb-2">{t('cta_trust3_title')}</h4>
              <p className="text-white/70 text-sm">{t('cta_trust3_desc')}</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
